module.exports = __webpack_public_path__ + "blue_arrow_icon.png";